<div class="itemMacroBox">
  <ng-container *ngIf="full; else miniT">
    <!-- <app-button class="kcalMacro menuMacroBig" [color]="'calorie'" [opacity]="[8,6,8]" [borderRad]="'15'">
			<div class="calname macroNameBig">{{"kCal" | translate}}</div>
			<div class="kcalVal macroValBig">{{item?.calories ?
			getParseFloat(item?.calories) : 0}}</div>
			</app-button>
			<app-button class="protein menuMacroBig" [color]="'prot'" [opacity]="[8,6,8]" [borderRad]="'15'">
			<div class="proname macroNameBig">{{"protein" | translate}}</div>
			<div class="proval macroValBig">{{item?.protein ?
			getParseFloat(item?.protein) : 0}}</div>
			</app-button>
			<app-button class="carbs menuMacroBig" [color]="'carb'" [opacity]="[8,6,8]" [borderRad]="'15'">
			<div class="carbname macroNameBig">{{"carbs" | translate}}</div>
			<div class="carbval macroValBig">{{item?.carbs ?
			getParseFloat(item?.carbs) : 0}}</div>
			</app-button>
			<app-button class="fats menuMacroBig" [color]="'fat'" [opacity]="[8,6,8]" [borderRad]="'15'">
			<div class="fatname macroNameBig">{{"fats" | translate}}</div>
			<div class="fatval macroValBig">{{item?.fats ?
			getParseFloat(item?.fats) : 0}}</div>
			</app-button> -->
    <div class="kcalMacro menuMacroBig">
      <div class="calname macroNameBig">{{ "kCal" | translate }}</div>
      <app-button
        class="kcalVal macroValBig"
        [color]="'calorie'"
        [opacity]="[8, 6, 8]"
        [borderRad]="'15'"
      >
        {{ item?.calories ? getParseFloat(item?.calories) : 0 }}
      </app-button>
    </div>
    <div class="protein menuMacroBig">
      <div class="proname macroNameBig">{{ "protein" | translate }}</div>
      <app-button
        class="proval macroValBig"
        [color]="'prot'"
        [opacity]="[8, 6, 8]"
        [borderRad]="'15'"
      >
        {{ item?.protein ? getParseFloat(item?.protein) : 0 }}
      </app-button>
    </div>
    <div class="carbs menuMacroBig">
      <div class="carbname macroNameBig">{{ "carbs" | translate }}</div>
      <app-button
        class="carbval macroValBig"
        [color]="'carb'"
        [opacity]="[8, 6, 8]"
        [borderRad]="'15'"
      >
        {{ item?.carbs ? getParseFloat(item?.carbs) : 0 }}
      </app-button>
    </div>
    <div class="fats menuMacroBig">
      <div class="fatname macroNameBig">{{ "fats" | translate }}</div>
      <app-button
        class="fatval macroValBig"
        [color]="'fat'"
        [opacity]="[8, 6, 8]"
        [borderRad]="'15'"
      >
        {{ item?.fats ? getParseFloat(item?.fats) : 0 }}
      </app-button>
    </div>
  </ng-container>
  <ng-template #miniT>
    <div class="macro-breakdown">
      <div class="macro-row">
        <span class="macro-label">{{ "calories" | translate }}</span>
        <span class="macro-value">{{
          item?.calories ? getParseFloat(item?.calories) : 0
        }}</span>
        <div class="bar-container">
          <div
            class="bar-gray"
            [style.background-color]="'var(--ion-ultra-grey)'"
          ></div>
          <div
            class="bar-filled"
            [style.background-color]="'var(--ion-color-success)'"
            [style.width]="
              getMacroPercentage(
                item?.calories ? getParseFloat(item?.calories) : 0,
                macroTotal
              )
            "
          ></div>
        </div>
      </div>

      <div class="macro-row">
        <span class="macro-label">{{ "f" | translate }}</span>
        <span class="macro-value"
          >{{ item?.fats ? getParseFloat(item?.fats) : 0 }}g</span
        >
        <div class="bar-container">
          <div
            class="bar-gray"
            [style.background-color]="'var(--ion-ultra-grey)'"
          ></div>
          <div
            class="bar-filled"
            [style.background-color]="'var(--ion-color-warning)'"
            [style.width]="
              getMacroPercentage(
                item?.fats ? getParseFloat(item?.fats) * 9 : 0,
                macroTotal
              )
            "
          ></div>
        </div>
      </div>

      <div class="macro-row">
        <span class="macro-label">{{ "c" | translate }}</span>
        <span class="macro-value"
          >{{ item?.carbs ? getParseFloat(item?.carbs) : 0 }}g</span
        >
        <div class="bar-container">
          <div
            class="bar-gray"
            [style.background-color]="'var(--ion-ultra-grey)'"
          ></div>
          <div
            class="bar-filled"
            [style.background-color]="'var(--ion-color-info)'"
            [style.width]="
              getMacroPercentage(
                item?.carbs ? getParseFloat(item?.carbs) * 4 : 0,
                macroTotal
              )
            "
          ></div>
        </div>
      </div>

      <div class="macro-row">
        <span class="macro-label">{{ "p" | translate }}</span>
        <span class="macro-value"
          >{{ item?.protein ? getParseFloat(item?.protein) : 0 }}g</span
        >
        <div class="bar-container">
          <div
            class="bar-gray"
            [style.background-color]="'var(--ion-ultra-grey)'"
          ></div>
          <div
            class="bar-filled"
            [style.background-color]="'var(--ion-color-warning)'"
            [style.width]="
              getMacroPercentage(
                item?.protein ? getParseFloat(item?.protein) * 4 : 0,
                macroTotal
              )
            "
          ></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
